import React, { useEffect, useState } from "react";
import api from "../../api";

const AssignReasoningToPractice = ({ setId, close }) => {
  const [questions, setQuestions] = useState([]);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    loadQuestions();
  }, []);

  const loadQuestions = async () => {
    try {
      const res = await api.get("/admin/reasoning-questions");
      setQuestions(res.data || []);
    } catch (e) {
      alert("Reasoning load failed");
    }
  };

  const toggle = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const submit = async () => {
    try {
      await api.post("/admin/practice-set/reasoning", {
        practice_set_id: setId,
        reasoning_question_ids: selected
      });
      alert("Reasoning assigned to practice set");
      close();
    } catch (e) {
      alert("Assign failed");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center">
      <div className="bg-white p-4 w-3/4 rounded">
        <h2 className="text-lg font-bold mb-3">
          Assign Reasoning to Practice Set #{setId}
        </h2>

        <div className="h-64 overflow-y-scroll border p-2 mb-3">
          {questions.map((q) => (
            <label key={q.id} className="block border p-2 mb-2 cursor-pointer">
              <input
                type="checkbox"
                checked={selected.includes(q.id)}
                onChange={() => toggle(q.id)}
                className="mr-2"
              />
              <img src={`/${q.image_url}`} alt="" style={{ width: 120 }} />
              <div style={{ fontSize: 13 }}>
                A. {q.option_a} <br />
                B. {q.option_b} <br />
                C. {q.option_c} <br />
                D. {q.option_d}
              </div>
            </label>
          ))}
        </div>

        <div className="flex justify-end gap-2">
          <button onClick={close} className="bg-gray-400 px-4 py-2 rounded text-white">
            Close
          </button>
          <button onClick={submit} className="bg-green-600 px-4 py-2 rounded text-white">
            Assign Selected
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssignReasoningToPractice;


